import Vue from "vue";
import Cookies from "js-cookie";
Cookies.set("hwlanguage", 'en-gb', { domain: "iccec.cn" })
import vueSwiper from "vue-awesome-swiper";
import "babel-polyfill"; // 兼容低版本IE,ES5模拟ES6新语法
import App from "./App.vue"; // 当前项目的挂载容器
import eventBus from "@/basa/utils/msgBus.js";
import router from "./basa/router"; // vue路由
import store from "./config/store"; // vuex
import i18n from "@/config/i18n";
import locale from "ccui/lib/locale";
import "ccui/lib/theme-chalk/index.css"; // CCUI样式
import globalComponents from "@/basa/common-set/globalComponents"; // 挂载的平台级公共函数
import appComponents from "@/config/app-set/appComponents"; // 自定义挂载应用级的公共函数
import CCUI from "@/config/app-set/ccui"; // ccui组件库配置文件，用来增删工程内用到的组件
import "./permission"; // 全局路由守卫等全局控制器
import directives from "./config/directives"; // 全局指令
import "./config/icons"; // SVG
import "./config/mock"; // mock数据
import "@/config/styles/index.scss"; // 项目所用公共css
import "swiper/dist/css/swiper.css";
import * as filters from "./basa/filters"; // 全局过滤器
import functions from "./basa/utils/functions"; // 全局方法
import searchComponents from "@/basa/components/search-component"; // 高级搜索所需自定义特殊组件
import dictionarySort from '@/basa/utils/dictionarySort.js'
import { tableThWidth } from "@/setting/setting.js";
Vue.prototype.msgCenter = new Vue()
    // import VueMatomo from "vue-matomo"; // 访问量所需插件
Vue.prototype.$dictionarySort = dictionarySort;
Vue.prototype.languagezh_cn = false //  'en-gb' //(Cookies.get("language") || "zh-cn") === "zh-cn";
if (window)
    window.languagezh_cn = false //'en-gb' // (Cookies.get("language") || "zh-cn") === "zh-cn";
if (window) window.$t = (key, value) => i18n.t(key, value);
locale.i18n((key, value) => i18n.t(key, value));
//中英文宽高
Vue.prototype.$TW = tableThWidth;
if (window) window.$TW = tableThWidth;
Vue.prototype.$eventBus = eventBus;
// 注册全局过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

// 生产环境不显示vue警告信息
Vue.config.productionTip = false;
// 注册全局方法
Vue.use(functions);
// 注册ccui组件
Vue.use(CCUI);

Vue.use(directives);
Vue.use(searchComponents);
// 注册平台级公共组件
Vue.use(globalComponents);
// 注册一些应用级组件
Vue.use(appComponents);

Vue.use(vueSwiper);
// 防止el-button重复点击
Vue.directive("preventReClick", {
    inserted(el, binding) {
        el.addEventListener("click", () => {
            if (!el.disabled) {
                el.disabled = true;
                setTimeout(() => {
                    el.disabled = false;
                }, binding.value || 2000);
            }
        });
    }
});
//全局组件
import listBaseTable from "@/basa/components/common/listBaseTable";
import computeUtil from "./config/utils/bigNumber";

Vue.component("listBaseTable", listBaseTable);

// 计算
window.$computeUtil = computeUtil;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");